import { SxProps } from '@mui/material'
import { brandColors, notificationColors } from '../Components/Common/Color/Color'

const disabledColor = 'rgba(224, 224, 224, 0.5)'

export const switchStyles: Record<string, SxProps> = {
  root: {
    '&.Mui-error': {
      '& .MuiSwitch-root.Mui-error': {
        '& .MuiSwitch-switchBase.Mui-checked': {
          color: notificationColors.red,
          '&:hover': {
            backgroundColor: 'rgba(225, 35, 57, 0.08)',
          },
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
          backgroundColor: notificationColors.red,
        },
        '&.Mui-disabled .MuiSwitch-switchBase': {
          color: disabledColor,
        },
        '&.Mui-disabled .MuiSwitch-track': {
          backgroundColor: 'rgba(255, 255, 255, 0.3)',
        },
      },
    },
  },
  primary: {
    '& .MuiSwitch-track': {
      backgroundColor: brandColors.purplePaleLavender,
    },
    '& .MuiSwitch-thumb': {
      color: brandColors.purpleDeluge,
    },
    '& .MuiSwitch-switchBase': {
      '&.Mui-checked': {
        color: brandColors.purpleEminence,
        '& + .MuiSwitch-track': {
          backgroundColor: brandColors.purpleEminence,
        },
        '& .MuiSwitch-thumb': {
          color: brandColors.purpleEminence,
        },
      },
      '&.Mui-disabled': {
        color: brandColors.purplePaleLavender,
        '& .MuiSwitch-thumb': {
          color: brandColors.purplePaleLavender,
        },
      },
    },
  },
  success: {
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: brandColors.greenSanFelix,
      '&:hover': {
        backgroundColor: 'rgba(31, 92, 9, 0.08)',
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: brandColors.greenSanFelix,
    },
    '&.Mui-disabled .MuiSwitch-switchBase': {
      color: disabledColor,
    },
    '&.Mui-disabled .MuiSwitch-track': {
      backgroundColor: 'rgba(255, 255, 255, 0.3)', // More white
    },
  },
  warning: {
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: notificationColors.amber,
      '&:hover': {
        backgroundColor: 'rgba(250, 202, 105, 0.08)',
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: notificationColors.amber,
    },
    '&.Mui-disabled .MuiSwitch-switchBase': {
      color: disabledColor,
    },
    '&.Mui-disabled .MuiSwitch-track': {
      backgroundColor: 'rgba(255, 255, 255, 0.3)', // More white
    },
  },
  default: {
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#E0E0E0',
      '&:hover': {
        backgroundColor: 'rgba(224, 224, 224, 0.08)',
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#E0E0E0',
    },
    '&.Mui-disabled .MuiSwitch-switchBase': {
      color: disabledColor,
    },
    '&.Mui-disabled .MuiSwitch-track': {
      backgroundColor: 'rgba(255, 255, 255, 0.3)', // More white
    },
  },
}
